import { InstituicaoConveniadaVO } from './instituicao-conveniada-vo.model';
import { ProjetoTipoClasse } from './projeto-tipo-classe.model';
import { Projeto } from './projeto.model';
import { Moment } from 'moment';

export class ProjetoConveniadoVO {

  id: number;
  entidade: string;
  identificacao: number;
  sigla: string;
  nome: string;
  dataInicio: Moment;
  dataFim: Moment;
  tipoProjeto: string;
  isEmpresaResponsavelPadis: boolean;
  optouSimplificadoEmpresaResponsavel: boolean;
  projeto: Projeto;
  projetoTipoClasse: ProjetoTipoClasse;
  instituicaoConveniadaVO: InstituicaoConveniadaVO;

  constructor(init?: Partial<ProjetoConveniadoVO>) {
    Object.assign(this, init);
  }

}
